import React, {useEffect, useMemo, useRef, useState} from 'react';
import { useParentScroll } from 'tea-component/lib/_util/use-parent-scroll';
// import { HokRegionCountry } from '../../pages/ExplorationAnalysis/components/widgets/hokRegionCountry';
import RegionSelect from '@/pages/home/components/RegionSelect';
import './RegionCountrySelector.scss';
import { useWindowSize } from '@/pages/dashboard/utils/customHook';

export interface RegionCountrySelectorProps {
  regionCountry: any[];
  value: any[];
  onChange: (act: string, country: any[], text: string) => void;
  isEn: boolean;
  popularList: any[]; // Region 组件下拉选
}

export function RegionCountrySelector(props: RegionCountrySelectorProps) {
  const { regionCountry, value, onChange, isEn, popularList } = props;
  const [regionMarket, setRegionMarket] = useState(value);
  const [manuallyCount, setManuallyCount] = useState(0);
  const countryRef = useRef(null);

  useEffect(() => {
    setRegionMarket(value);
  }, [JSON.stringify(value)]);

  useEffect(() => {
    const columnText = `${countryRef?.current?.querySelector('.region-container___3sjAE')?.outerHTML}`;
    onChange('include', regionMarket, columnText);
  }, [JSON.stringify(regionMarket), manuallyCount]);

  const convertRegion2Country = (tags: any) => {
    if (tags.region_type != 'region') {
      return tags.regions;
    }
    if (tags.regions.some((region: string) => region === 'All Areas')) {
      return [];
    }
    const country: string[] = [];
    tags.regions.reduce((previousValue: any[], currentValue: string) => {
      const region = regionCountry.find((item) => item.region_key === currentValue);
      previousValue.push(...(region?.country.map((item) => item.country_name_abbre) || []));
      return previousValue;
    }, country);
    return country;
  };

  useParentScroll(countryRef, (event) => {
    const e = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    event?.target?.dispatchEvent(e);
  });

  const windowSize = useWindowSize();
  // 动态计算top
  const dropdownHeight = 405; // 弹框高度
  const regionHeight = 36; // 筛选器按钮高度
  const marginTop = 10; // 顶部偏移
  const bottom = countryRef?.current?.querySelector('.container___1IaPA')?.getBoundingClientRect()?.bottom;
  useEffect(() => {
    const containerTop = window.document.querySelector('.explore-analysis')?.getBoundingClientRect()?.top;
    const elem = countryRef?.current?.querySelector('.fs-region-country-dropdown');
    const mayTop = bottom - dropdownHeight - regionHeight - marginTop;
    if (windowSize.height > bottom + dropdownHeight) {
      elem.style.top = `${bottom}px`;
    } else if (mayTop < containerTop) {
      elem.style.top = `${containerTop}px`;
    } else {
      elem.style.top = `${mayTop}px`;
    }
  }, [bottom, windowSize]);
  
  const localRegionCountries = useMemo(() => {
    try {
      return regionCountry?.map((region) => ({
        region_abbre: region?.region_abbre,
        region_key: region?.region_key,
        region_name_cn: isEn ? region?.region_name_en : region?.region_name_cn,
        region_name_en: isEn ? region?.region_name_en : region?.region_name_cn,
        country: region?.country?.map((item) => ({
          country_name_abbre: item?.country_name_abbre,
          deviation: item?.deviation,
          country_name_cn: isEn ? item?.country_name_en : item?.country_name_cn,
          country_name_en: isEn ? item?.country_name_en : item?.country_name_cn,
        }))
      })
      );
    } catch (e) {
      return [];
    }
  }, [isEn]) || [];
  return (
    <div ref={countryRef} style={{ marginLeft: '10px' }}>
      <RegionSelect
        locale={isEn ? "en-US" : "zh-CN"}
        className="fs-region-country"
        dropdownClassName="fs-region-country-dropdown"
        regionType={'market'}
        regionCountry={localRegionCountries}
        defaultValue={regionMarket}
        value={regionMarket}
        onChange={() => {
          setManuallyCount(manuallyCount + 1);
        }}
        onConfirm={(tags: any) => {
          // tags 选中的数据
          setRegionMarket(convertRegion2Country(tags));
        }}
        popularList={popularList}
        globalMessageHidden={true}
        resultLable={undefined}
        showUnidentified={false}
        hiddenNoChina={true}
        showChinese={false}
      />
    </div>
  );
}
